import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface TariffListOcpiTariffIdCellProps
  extends CellContext<TariffModel, TariffModel['ocpiTariffId']> {}

export const TariffListOcpiTariffIdCell = (
  props: TariffListOcpiTariffIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(generatePath(APP_PATH.TARIFF.DETAILS, { id: row.original.id }))
      }>
      <div style={{ maxWidth: '100px', overflow: 'hidden' }}>
        <Text truncate>{getValue()}</Text>
      </div>
    </Link>
  );
};
